var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#","title":_vm.text.delete + ' ' + _vm.linkName},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.text.delete))])}
var staticRenderFns = []

export { render, staticRenderFns }